import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  id: "bookingOverview",
  class: "easy-drop full-mobile no-query"
}
const _hoisted_4 = { class: "footer" }
const _hoisted_5 = {
  class: "mobile-trigger",
  hidden: ""
}
const _hoisted_6 = { class: "drop-content" }
const _hoisted_7 = {
  class: "back-btn",
  href: "/"
}
const _hoisted_8 = { class: "js-calcChildHeight" }
const _hoisted_9 = { class: "booking-overview-item travel-item" }
const _hoisted_10 = { class: "booking-overview-item hotel-item" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "booking-overview-item" }
const _hoisted_13 = { class: "booking-overview-item" }
const _hoisted_14 = { class: "booking-overview-item" }
const _hoisted_15 = { class: "booking-overview-item" }
const _hoisted_16 = { class: "booking-overview-item" }
const _hoisted_17 = { class: "booking-overview-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("a", {
      class: "back-btn",
      href: _ctx.pageUrls.pageHotelList
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      id: "overviewOpen",
      class: _normalizeClass({ active: _ctx.tabletActive }),
      hidden: ""
    }, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tabletActive = !_ctx.tabletActive))
      }, [
        (!_ctx.tabletActive)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewHeadline']), 1))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("aside", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewAddDatesAndSearch']), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickDatePicker && _ctx.clickDatePicker(...args)))
            }, _toDisplayString(_ctx.pageTexts['searchbarDateLabelChooseDate']), 1)
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["drop-open", { active: _ctx.isActive }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isActive = !_ctx.isActive))
      }, null, 2),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("nav", null, [
          _createElementVNode("header", null, [
            _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelBackToFrontPage']), 1),
            _createElementVNode("h2", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewHeadline']), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelYourTravel']) + " ", 1),
                  _createElementVNode("a", null, [
                    _createElementVNode("small", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickDatePicker && _ctx.clickDatePicker(...args)))
                    }, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelYourTravelInactiveDate']), 1),
                    _createElementVNode("small", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickTravellersPicker && _ctx.clickTravellersPicker(...args)))
                    }, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelYourTravelInactivePerson']), 1),
                    _createElementVNode("small", {
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickAirportPicker && _ctx.clickAirportPicker(...args)))
                    }, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelYourTravelInactiveDepartureAirport']), 1)
                  ])
                ])
              ]),
              _createElementVNode("span", _hoisted_10, [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelHotelInactive']) + " ", 1),
                  _createElementVNode("small", { innerHTML: _ctx.hotelName }, null, 8, _hoisted_11)
                ])
              ]),
              _createElementVNode("span", _hoisted_12, [
                _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelRoom']), 1)
              ]),
              _createElementVNode("span", _hoisted_13, [
                _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelCatering']), 1)
              ]),
              _createElementVNode("span", _hoisted_14, [
                _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelFlight']), 1)
              ]),
              _createElementVNode("span", _hoisted_15, [
                _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelTransfer']), 1)
              ]),
              _createElementVNode("span", _hoisted_16, [
                _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelPersonalInformation']), 1)
              ]),
              _createElementVNode("span", _hoisted_17, [
                _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelConfirmAndPay']), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}